var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1180_665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7802 17.7146C10.9375 18.1255 7.0619 18.1255 3.21918 17.7146C2.47425 17.635 1.77908 17.3026 1.24942 16.7727C0.719767 16.2429 0.387583 15.5476 0.308181 14.8026C-0.102727 10.9599 -0.102727 7.08436 0.308181 3.24164C0.387838 2.49671 0.720262 1.80154 1.2501 1.27189C1.77994 0.742228 2.47522 0.410044 3.22018 0.330642C7.06289 -0.0802661 10.9385 -0.0802661 14.7812 0.330642C15.5261 0.410299 16.2213 0.742723 16.7509 1.27256C17.2806 1.8024 17.6128 2.49768 17.6922 3.24264C18.1031 7.08536 18.1031 10.9609 17.6922 14.8036C17.6127 15.5486 17.2803 16.2439 16.7505 16.7736C16.2206 17.3033 15.5252 17.6354 14.7802 17.7146Z",
    fill: "url(#paint0_linear_1180_665)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.713 3.8935C16.6427 3.23242 16.348 2.61539 15.878 2.1452C15.408 1.67502 14.7911 1.38007 14.13 1.3095C10.7201 0.94501 7.281 0.94501 3.87104 1.3095C3.20988 1.38003 2.59283 1.67494 2.12266 2.14511C1.65249 2.61528 1.35758 3.23233 1.28704 3.8935C0.922548 7.30345 0.922548 10.7425 1.28704 14.1525C1.3574 14.8137 1.65225 15.4309 2.12246 15.9011C2.59266 16.3713 3.20981 16.6661 3.87104 16.7365C7.28099 17.1011 10.7201 17.1011 14.13 16.7365C14.7913 16.6661 15.4084 16.3713 15.8786 15.9011C16.3488 15.4309 16.6437 14.8137 16.714 14.1525C17.0784 10.7425 17.078 7.30341 16.713 3.8935Z",
    fill: "url(#paint1_linear_1180_665)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.27002 14.4243C0.282686 14.549 0.295353 14.6733 0.30802 14.7973C0.387499 15.5423 0.719864 16.2376 1.24974 16.7673C1.77961 17.297 2.47499 17.6291 3.22002 17.7083C7.06273 18.1193 10.9383 18.1193 14.781 17.7083C15.5259 17.6289 16.221 17.2967 16.7507 16.767C17.2804 16.2373 17.6126 15.5422 17.692 14.7973C17.7054 14.6727 17.7184 14.5483 17.731 14.4243H0.27002Z",
    fill: "url(#paint2_linear_1180_665)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4982 15.6166L5.88218 4.0006C5.75942 3.83986 5.60371 3.70721 5.42549 3.61157C5.24728 3.51592 5.05068 3.45947 4.84886 3.44602C4.64705 3.43256 4.44469 3.4624 4.25536 3.53354C4.06602 3.60468 3.89408 3.71547 3.75106 3.85849C3.60804 4.00151 3.49725 4.17345 3.42611 4.36279C3.35497 4.55212 3.32514 4.75448 3.33859 4.95629C3.35205 5.1581 3.4085 5.35471 3.50414 5.53292C3.59979 5.71114 3.73243 5.86684 3.89317 5.9896L15.4682 17.5656C15.9299 17.4117 16.3516 17.1569 16.7027 16.8198C17.0539 16.4827 17.3256 16.0717 17.4982 15.6166Z",
    fill: "url(#paint3_linear_1180_665)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.94699 7.2085H3.56299V14.5975L6.94499 17.9795C9.55973 18.0785 12.1782 17.9886 14.78 17.7105C15.2242 17.6632 15.6541 17.5254 16.043 17.3055L5.94699 7.2085Z",
    fill: "url(#paint4_linear_1180_665)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.045 7.83064C13.8218 7.58519 13.5498 7.38916 13.2463 7.25517C12.9429 7.12118 12.6147 7.05219 12.283 7.05264C11.4703 7.02226 10.6743 7.28807 10.043 7.80064L9.57599 7.21165H7.37598V14.6006L10.768 17.9926C12.106 17.9493 13.443 17.8563 14.779 17.7136C15.5238 17.6342 16.219 17.302 16.7487 16.7723C17.2783 16.2426 17.6105 15.5475 17.69 14.8026C17.7993 13.776 17.8797 12.749 17.931 11.7216L14.045 7.83064Z",
    fill: "url(#paint5_linear_1180_665)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.56299 7.20752H5.94598V14.5965H3.56299V7.20752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.28 7.05226C11.7586 7.01751 11.2369 7.1154 10.7636 7.33677C10.2902 7.55815 9.88063 7.89581 9.57304 8.31827V7.21127H7.37305V14.6003H9.75705V10.8883C9.75705 9.81526 10.251 8.98126 11.187 8.98126C12.123 8.98126 12.277 10.0193 12.277 11.2963V14.5963H14.661V9.43126C14.6597 8.80037 14.4084 8.19573 13.9621 7.74981C13.5158 7.30389 12.9109 7.05305 12.28 7.05226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.17296 4.86236C6.17296 5.14301 6.08974 5.41736 5.93382 5.65071C5.7779 5.88406 5.55628 6.06594 5.29699 6.17334C5.0377 6.28074 4.75238 6.30884 4.47713 6.25409C4.20187 6.19934 3.94903 6.0642 3.75058 5.86575C3.55213 5.66729 3.41698 5.41445 3.36223 5.13919C3.30747 4.86393 3.33558 4.57862 3.44298 4.31933C3.55038 4.06004 3.73225 3.83842 3.96561 3.6825C4.19896 3.52658 4.47331 3.44336 4.75397 3.44336C5.13031 3.44336 5.49123 3.59286 5.75735 3.85897C6.02346 4.12508 6.17296 4.48602 6.17296 4.86236Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1180_665",
    x1: 5.97612,
    y1: 2.56051,
    x2: 10.5302,
    y2: 12.2987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1180_665",
    x1: 12.802,
    y1: 11.0677,
    x2: -13.3467,
    y2: -2.95666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066B2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07485E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1180_665",
    x1: 9.00052,
    y1: 14.6363,
    x2: 9.00052,
    y2: 18.3973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066B2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07485E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1180_665",
    x1: 9.53872,
    y1: 9.64275,
    x2: 2.83049,
    y2: 2.90136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066B2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07485E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1180_665",
    x1: 13.4846,
    y1: 15.8997,
    x2: 0.895121,
    y2: 8.02291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066B2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07485E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1180_665",
    x1: 16.791,
    y1: 17.2923,
    x2: 7.01681,
    y2: 8.20119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066B2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07485E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1180_665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.0224609)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLin);
export default __webpack_public_path__ + "static/media/lin.2e110233a413b348e5ae1aeb4c6f6c7a.svg";
export { ForwardRef as ReactComponent };